import React from 'react';

import { CompareCheckbox } from '../compare-checkbox';
import { DealBadge } from '../deal-badge';
import { ProductMedia } from '../media';

import { BrandLogo, Media } from './styles';

import type { BaseProps } from '../../types';

type Props = Pick<
  BaseProps,
  | 'brand'
  | 'diffPercentage'
  | 'imageSrc'
  | 'name'
  | 'selectable'
  | 'selected'
  | 'imageSize'
  | 'shouldLazyLoadImage'
> & { marginRem?: number };

export const GridCardHeader: React.FC<Props> = props => {
  const {
    brand,
    diffPercentage,
    imageSrc,
    marginRem = 1,
    name,
    selectable,
    selected = false,
    imageSize = 140,
    shouldLazyLoadImage = false,
  } = props;

  return (
    <>
      {selectable ? <CompareCheckbox selected={selected} /> : null}

      <Media
        $marginRem={marginRem}
        $size={shouldLazyLoadImage ? `${imageSize}px` : 'auto'}
      >
        {brand?.logo && <BrandLogo src={brand.logo} alt={brand.name || ''} />}

        {diffPercentage ? (
          <DealBadge diffPercentage={diffPercentage} marginRem={marginRem} />
        ) : null}

        <ProductMedia
          lazyLoadImage={shouldLazyLoadImage}
          imageSize={imageSize}
          imageSrc={imageSrc}
          name={name || ''}
        />
      </Media>
    </>
  );
};
